import SquareEmptyQuestionIcon from "./SquareEmptyQuestionIcon.mjs";

export default class MyLeafIcon extends SquareEmptyQuestionIcon {}
